import Container from "../../layout/Container"
import Navbar from "../../layout/Navbar"
import HomeSearch from "../../components/elements/HomeSearch"
import GuideCardSm from "../../components/cards/GuideCardSm"
import { useFetch } from "../../hooks/useFetch"
import { getGuides } from "../../apis"
import useWidth from "../../hooks/useWidth"
import GuideMobile from '../mobile/Guides'
import Icon from "../../components/Icon"
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import Loader from "../../components/elements/Loader"


export default () => {
    const width = useWidth()
    const [ guideFilters, setGuideFilters ] = useState({ search: null, category: null, city: "mathura" })
    const [filters, setFilters] = useState([])

    const [guides,,loading] = useFetch(getGuides, [], guideFilters )

    const addFilter = ( check, value ) => {
        if( check ) setFilters([ ...filters, value ])
        else setFilters( prev => prev.filter( filter => filter !== value ))
    }

    return (
        <>
            <Loader loading={loading} />
            {width < 992 ? <GuideMobile guides={guides} filters={guideFilters} setFilters={setGuideFilters} /> :
            <>
                <Navbar gradient />
                <Container >
                    <section className="s desktop-top-space">
                        <div className="d-flex justify-content-center flex-column align-items-center guide-page-title ">
                            <p className="custom-text-color xx-bold text-center  fs-1 ">Search Results</p>
                            <HomeSearch placeholder={"Local Guide"} onSearch={ search => setGuideFilters({ ...guideFilters, search })} />
                        </div>

                        <div className="row p-0">
                            <div className="col-lg-3">
                                <div className="card rounded-4 p-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <p className="mb-0 fs-6 bold">Filter By:</p>
                                        <p className="text-saffron fs-8" onClick={() =>  setFilters([])}>Clear</p>
                                    </div>

                                    <div className="d-flex gap-2 flex-wrap">
                                        {
                                            filters?.map( filter => 
                                                <span className="px-2 py-1 rounded-5 bg-saffron text-white fs-9 text-nowrap">{ filter } <Icon icon={faXmarkCircle} className="ms-2" onClick={() => setFilters( prev => prev.filter( f => filter !== f ))} /></span>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="card rounded-4 p-3 mt-3">
                                    <p className="mb-0 fs-6 bold">Category</p>

                                    <div className=" mt-3">
                                        <label htmlFor={`category-1`} className="d-flex align-items-center mb-1">
                                            <input type="checkbox" id={`category-1`} onChange={e => (setGuideFilters({ ...guideFilters, category: "Best Related "}), addFilter(e.target.checked, "Best Related")) } checked={ filters.includes("Best Related") } />
                                            <p className="ps-2 mb-0 fs-8">Best Related</p>
                                        </label>
                                        <label htmlFor={`category-2`} className="d-flex align-items-center mb-1">
                                            <input type="checkbox" id={`category-2`} onChange={e => (setGuideFilters({ ...guideFilters, category: "English Speaking" }), addFilter(e.target.checked, "English Speaking")) } checked={ filters.includes("English Speaking") } />
                                            <p className="ps-2 mb-0 fs-8">English Speaking</p>
                                        </label>

                                        <label htmlFor={`category-3`} className="d-flex align-items-center mb-1">
                                            <input type="checkbox" id={`category-3`} onChange={e => (setGuideFilters({ ...guideFilters, category: "Near Me" }), addFilter(e.target.checked, "Near Me")) } checked={ filters.includes("Near Me") } />
                                            <p className="ps-2 mb-0 fs-8">Near Me</p>
                                        </label>

                                        <label htmlFor={`category-4`} className="d-flex align-items-center mb-1">
                                            <input type="checkbox" id={`category-4`} onChange={e => (setGuideFilters({ ...guideFilters, category: "Price" }), addFilter(e.target.checked, "Price")) } checked={ filters.includes("Price") } />
                                            <p className="ps-2 mb-0 fs-8">Price</p>
                                        </label>

                                        <label htmlFor={`category-5`} className="d-flex align-items-center mb-1">
                                            <input type="checkbox" id={`category-5`} onChange={e => (setGuideFilters({ ...guideFilters, category: "Recommended" }), addFilter(e.target.checked, "Recommended")) } checked={ filters.includes("Recommended") } />
                                            <p className="ps-2 mb-0 fs-8">Recommended</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-12">
                                <div className="card rounded-4 p-4">
                                    <h4 className="custom-text-color">Find your local tour guide with Showaround </h4>
                                    <div className="row mt-4">
                                        {
                                            guides?.map(( guide, i )=>
                                                <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0" key={i}>
                                                    <GuideCardSm guide={guide} />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </Container>
            </>}
        </>
    )
}
